define("shared/components/shared/profile-categorization/categorize-steps/search-box", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "shared/utils/uuid"], function (_exports, _component, _templateFactory, _component2, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"shared/utils/uuid"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @showSearchBox}}
  
    <input
      autocomplete="off"
      class="o--form__input qa--other_industry_input u--m__t__sm qa--categorize_search_box_input"
      id={{this.inputId}}
      onkeyup={{action @onKeyupAction value="target.value"}}
      placeholder={{@placeholder}}
      type="text"
      value={{@inputValue}}
    />
  
    <Shared::Ui::EmberDrop
      @constrainToScrollParent={{true}}
      @constrainToWindow={{true}}
      @contentSelector="#{{this.resultsId}}"
      @openOn={{if @isManualDrop null undefined}}
      @position="bottom left"
      @setCloseAction={{if @setCloseAction @setCloseAction}}
      @setOpenAction={{if @setOpenAction @setOpenAction}}
      @target="#{{this.inputId}}"
      class="qa--categorize_search_box_drop"
    >
  
      <Shared::Ui::SearchBox::Results
        @onSelectAction={{@onSelectAction}}
        @searchResults={{@searchResults}}
        class="ePT--industry--drop qa--categorize_search_box_results"
        id={{this.resultsId}}
      />
  
    </Shared::Ui::EmberDrop>
  
  {{/if}}
  */
  {
    "id": "LDmvbZWC",
    "block": "[[[41,[30,1],[[[1,\"\\n  \"],[10,\"input\"],[14,\"autocomplete\",\"off\"],[14,0,\"o--form__input qa--other_industry_input u--m__t__sm qa--categorize_search_box_input\"],[15,1,[30,0,[\"inputId\"]]],[15,\"onkeyup\",[28,[37,1],[[30,0],[30,2]],[[\"value\"],[\"target.value\"]]]],[15,\"placeholder\",[30,3]],[15,2,[30,4]],[14,4,\"text\"],[12],[13],[1,\"\\n\\n  \"],[8,[39,2],[[24,0,\"qa--categorize_search_box_drop\"]],[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@openOn\",\"@position\",\"@setCloseAction\",\"@setOpenAction\",\"@target\"],[true,true,[29,[\"#\",[30,0,[\"resultsId\"]]]],[52,[30,5],null,[27]],\"bottom left\",[52,[30,6],[30,6]],[52,[30,7],[30,7]],[29,[\"#\",[30,0,[\"inputId\"]]]]]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[39,3],[[24,0,\"ePT--industry--drop qa--categorize_search_box_results\"],[16,1,[30,0,[\"resultsId\"]]]],[[\"@onSelectAction\",\"@searchResults\"],[[30,8],[30,9]]],null],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\\n\"]],[]],null]],[\"@showSearchBox\",\"@onKeyupAction\",\"@placeholder\",\"@inputValue\",\"@isManualDrop\",\"@setCloseAction\",\"@setOpenAction\",\"@onSelectAction\",\"@searchResults\"],false,[\"if\",\"action\",\"shared/ui/ember-drop\",\"shared/ui/search-box/results\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/search-box.hbs",
    "isStrictMode": false
  });

  class SearchBoxComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "inputId", `search-box-input-${(0, _uuid.default)()}`);

      _defineProperty(this, "resultsId", `search-box-results-${(0, _uuid.default)()}`);
    }

  }

  _exports.default = SearchBoxComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SearchBoxComponent);
});